import { Link, useSearchParams } from 'react-router-dom'

export default function NotFoundPage() {
  const [searchParams] = useSearchParams()
  const reason = searchParams.get('reason')
  const isUnauthorized = reason === 'unauthorized'

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <img src="/images/logo-512.png" alt="Fluffy Fox Ear" className="w-24 h-24 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          {isUnauthorized ? 'Сессия истекла' : 'Страница не найдена'}
        </h1>
        <p className="text-gray-600 mb-6">
          {isUnauthorized
            ? 'Войдите заново для доступа к проектам.'
            : 'Проверьте адрес или войдите в аккаунт.'}
        </p>
        <div className="flex gap-3 justify-center">
          <Link
            to="/login"
            className="inline-block bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition font-medium"
          >
            Войти через Telegram
          </Link>
          <Link
            to="/"
            className="inline-block bg-gray-100 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-200 transition font-medium"
          >
            На главную
          </Link>
        </div>
      </div>
    </div>
  )
}
